import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { styleVariables } from '@lib/common';
import { SubmissionStatusId } from '@module/assignment';
import { styled } from '@xstyled/styled-components';
import { getDateTime, getTimeStr } from '../utils';
import { PracticeSubmissionStatusResultComponent } from '../pratice-submission-status-result.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledCorrectPercentText = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 600;\n  color: ", ";\n"])), function (_ref) {
  var statusType = _ref.statusType;
  return statusType == SubmissionStatusId.SUBMITTED ? "".concat(styleVariables.colors.green1) : "".concat(styleVariables.colors.red4);
});
var StyledResultRow = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export var renderColumns = function renderColumns(_ref2) {
  var attendeeSubmissionTranslation = _ref2.attendeeSubmissionTranslation,
      totalQuestions = _ref2.totalQuestions;
  return [{
    width: '25%',
    title: attendeeSubmissionTranslation.startEndDate,
    key: 'startEndDate',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.createdAt ? getDateTime(+record.createdAt) : '-'
      });
    }
  }, {
    width: '25%',
    title: attendeeSubmissionTranslation.duration,
    dataIndex: 'duration',
    key: 'duration',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: getTimeStr(record.elapsedTime, {
          h: attendeeSubmissionTranslation.hour,
          m: attendeeSubmissionTranslation.minute,
          s: attendeeSubmissionTranslation.second
        }) || '-'
      });
    }
  }, {
    width: '32%',
    title: attendeeSubmissionTranslation.correctPercent,
    key: 'correctPercent',
    render: function render(_, record) {
      var _record$result, _record$result2, _record$result2$statu, _record$result3;

      return /*#__PURE__*/_jsx(_Fragment, {
        children: ((_record$result = record.result) === null || _record$result === void 0 ? void 0 : _record$result.expectationResult) !== null ? /*#__PURE__*/_jsxs(StyledCorrectPercentText, {
          statusType: (_record$result2 = record.result) === null || _record$result2 === void 0 ? void 0 : (_record$result2$statu = _record$result2.status) === null || _record$result2$statu === void 0 ? void 0 : _record$result2$statu.id,
          children: [(_record$result3 = record.result) === null || _record$result3 === void 0 ? void 0 : _record$result3.expectationResult, "%"]
        }) : '-'
      });
    }
  }, {
    width: '18%',
    title: attendeeSubmissionTranslation.result,
    key: 'result',
    render: function render(_, record) {
      var _record$result4, _record$result5, _record$result5$statu, _record$result5$statu2;

      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(StyledResultRow, {
          children: (_record$result4 = record.result) !== null && _record$result4 !== void 0 && _record$result4.status ? /*#__PURE__*/_jsx(PracticeSubmissionStatusResultComponent, {
            status: ((_record$result5 = record.result) === null || _record$result5 === void 0 ? void 0 : (_record$result5$statu = _record$result5.status) === null || _record$result5$statu === void 0 ? void 0 : (_record$result5$statu2 = _record$result5$statu.id) === null || _record$result5$statu2 === void 0 ? void 0 : _record$result5$statu2.toString()) || ''
          }) : '-'
        })
      });
    }
  }];
};